import axios from 'axios';
import _get from 'lodash/get';
import { config } from '../../Configs';

export const GetCouponAPI = async (
  couponId,
  captchaToken,
  axiosSource = null
) => {
  try {
    const configObj = {
      params: { 'g-recaptcha-response': captchaToken }
    };

    if (axiosSource !== null) {
      configObj.cancelToken = axiosSource.token;
    }

    const response = await axios.get(
      `${config.api.url}/coupons/${couponId}`,
      configObj
    );

    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err, isCancel: axios.isCancel(err) };
  }
};

export const GetCouponByContractAPI = async (contractId, captchaToken) => {
  try {
    const configObj = {
      params: { 'g-recaptcha-response': captchaToken }
    };

    const response = await axios.get(
      `${config.api.url}/coupons/getByContract/${contractId}`,
      configObj
    );

    const coupon = _get(response, 'data.data.coupon');

    if (!coupon) {
      return { success: false, error: 'Cupón no encontrado' };
    }

    return {
      success: true,
      data: {
        city: coupon.CITY,
        address: coupon.ADDRESS,
        value: coupon.CUPOVALO,
        number: coupon.CUPONUME
      }
    };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const GenerateDuplicateCouponAPI = async (
  contractId,
  period,
  authToken = null,
  origin
) => {
  try {
    const configObj = {};
    if (authToken !== null) {
      configObj.headers = { Authorization: authToken };
    }
    const response = await axios.post(
      `${config.api.url}/contracts/duplicate/${contractId}`,
      {
        period,
        origin
      },
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const GetDuplicateCouponPDFAPI = async (couponId, period) => {
  try {
    const configObj = { params: { period } };
    const response = await axios.get(
      `${config.api.url}/contracts/duplicate/pdf/${couponId}`,
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const GetDuplicateInvoicesAPI = async params => {
  const configObj = {
    params: {
      'g-recaptcha-response': params.captchaToken
    }
  };
  try {
    const response = await axios.get(
      `${config.api.url}/contracts/duplicate/${params.contractId}`,
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const GetCouponPDFAPI = async couponId => {
  try {
    const response = await axios.get(
      `${config.api.url}/coupons/pdf/${couponId}`
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};
